import React, { Suspense, lazy } from 'react';
import { useState, useRef, useEffect } from 'react';
import { useSelector } from "react-redux/es/exports";
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { useOutsideClick } from "../shared/hooks/useOutsideClick";
import { LoginPage } from '../Pages/login-user-page';
import { Register } from '../Pages/register-user-page';
import { getAvatar} from "../shared/api/avatarService";
import { DEFAULT_AVATAR_URL, handleAvatarLoadError } from '../shared/lib/avatarFallback';
import logo from '../shared/lib/icons/svg/logo_timetask.svg';
import { UserMenu, UserMenuMobile } from '../widgets/user-menu';
// import './App.css';
// import TaskSelection from "./GroupTaskEditing/TaskSelection";
import { ReactComponent as BurgerMenu } from "../shared/lib/icons/svg/menu_ic/burger_menu_mobile.svg";
import { ReactComponent as ArrowDown } from "../shared/lib/icons/svg/menu_ic/arrow_down_pagePicker.svg";
import { DDselectPage } from '../features/select-page-mobile';
import { ReactComponent as CalendarSvg } from "../shared/lib/icons/svg/submenu_ic/calendar-active.svg";
import { ReactComponent as TodaySvg } from "../shared/lib/icons/svg/submenu_ic/element-1-active.svg";
import { ReactComponent as IncomingSvg } from "../shared/lib/icons/svg/submenu_ic/filled-active.svg";
import { ReactComponent as NotesIcon } from "../shared/lib/icons/svg/Notes_shared/notepad-icon.svg";
import { Button } from '../shared/ui/Button';
import request from './api/requests';
import { loadUserSettings } from '../shared/lib/store/settingsReducer';
import { connectionHubContext } from '../shared/contexsts/connectionHubContext';
import Feedback from '../widgets/feedback/ui/Feedback';
import Loader from '../shared/ui/loader-circle/lodaer-circle';
import useTimeZone from '../shared/hooks/useTimeZone';
import { ModalWindow } from '../shared/ui/modal';
import { EPG } from '../shared/ui/EventPictureGenerator/EventPictureGenerator';
import ConverterUTC from '../shared/lib/converterUTC/ConverterUTC';
import { endSession, getAccessToken, getRefreshToken, subscribeSessionEnd, subscribeSessionRecovered } from '../shared/lib/auth/session';
import { TimerError } from '../features/timer/ui/TimerError';
import { useTimerSync } from '../shared/hooks/useTimerSync';
import { startUserHub } from './api/startUserHub';
import { taskCreated } from '../shared/lib/store/taskUpdatesReducer';
import { getUserData } from '../features/user/getUserData';
import { RootState, useAppDispatch } from './store';
import type { HubConnection } from '@microsoft/signalr';
import { MenuPageSelect, SettingsUserState } from '../shared/lib/types/Types';
import { UserAuthActionTypes } from '../features/user/userStore';
import { getTagsList } from '../features/select-tags/api/getTagsList';
import { useDeviceWidth } from '../shared/hooks/useDeviceWidth';
import FocusTaskBtn from '../features/focus-task/compose/focus-task-btn/ui/focus-task-btn';
import { focusedTaskSlice } from '../features/focus-task/model/focus-task.slice';
import { MatrixButton } from '../features/matrix-task/compose/matrix-btn';
import { loginLocationAfterSessionExpired } from '../entities/subscription/model/payment-return-location';
import { useSubscriptionSync } from './model/use-subscription-sync';
import { SubscriptionPaymentReturnPage } from '../Pages/subcsription-page/ui/compose/payment-return-status';

const CompletedTodosPage = lazy(() => import('../Pages/completed-tasks-page').then(m => ({ default: m.CompletedTodosPage })));
const DeletedTodosPage = lazy(() => import('../Pages/deleted-tasks-page').then(m => ({ default: m.DeletedTodosPage })));
const IncomingTodosPage = lazy(() => import('../Pages/incoming-tasks-page').then(m => ({ default: m.IncomingTodosPage })));
const TodayTask = lazy(() => import('../Pages/today-tasks-page').then(m => ({ default: m.TodayTask })));
const NotFoundPage = lazy(() => import('../Pages/not-found-page').then(m => ({ default: m.NotFoundPage })));
const TagsPage = lazy(() => import('../Pages/tags-page').then(m => ({ default: m.TagsPage })));
const Settings = lazy(() => import('../Pages/settings-page/SettingsPage'));
const ForgotPassword = lazy(() => import('../Pages/forgot-password-page').then(m => ({ default: m.ForgotPassword })));
const ResetPasswordP = lazy(() => import('../Pages/reset-password-page').then(m => ({ default: m.ResetPasswordP })));
const CalendarPage = lazy(() => import('../Pages/calendar-page').then(m => ({ default: m.CalendarPage })));
const SuccessPage = lazy(() => import('../Pages/success-page').then(m => ({ default: m.SuccessPage })));
const EditModalTask = lazy(() => import('../widgets/edit-modal-task/ui/EditModalTask'));
const Privacy = lazy(() => import('../Pages/privacy-page').then(m => ({ default: m.Privacy })));
const RepeatTemplatePage = lazy(() => import('../Pages/repeat-templates-page').then(m => ({ default: m.RepeatTemplatePage })));
const SuccessGoogle = lazy(() => import('../Pages/success-goolge-page').then(m => ({ default: m.SuccessGoogle })));
const SuccessAuth = lazy(() => import('../Pages/login-user-page/AuthVariants/AuthStatusPage/SuccessAuth'));
const TaskTemplatePage = lazy(() => import('../Pages/templates-tasks-page').then(m => ({ default: m.TaskTemplatePage })));
const NotesPage = lazy(() => import('../Pages/notes-page/ui/notes-page').then(m => ({ default: m.NotesPage })));
const NotesPageMobile = lazy(() => import('../Pages/notes-page/ui/notes-page-mobile').then(m => ({ default: m.NotesPageMobile })));
const SubscriptionPage = lazy(() => import('../Pages/subcsription-page/ui/subcsription-page').then(m => ({ default: m.SubscriptionPage })));
const ProductivitySummaryPreview = lazy(() => import('../Pages/productivity-summary-preview/productivity-summary-preview').then(m => ({ default: m.ProductivitySummaryPreview })));

function App() {
  useSubscriptionSync();
  localStorage.setItem('interceptorTry', 'false');
  const navigate = useNavigate();
  const dispatch = useAppDispatch()
  const userMenuRef = useRef<HTMLLIElement>(null);
  const [menuActiv, setMenuActiv] = useState(false);
  const [menuPage, setMenuPage] = useState(false);
  const [pageName, setPageName] = useState({ pageName: 'Мой день', index: 0 });
  const { windowScreen } = useDeviceWidth();
  const [isDisabledHeaderBtns, setIsDisabledHeaderBtns] = useState(true);
  const userSettings = useSelector((state: SettingsUserState) => state.settings.settings);
  const { loading, isAuth, error: sessionError } = useSelector((state: RootState ) => state.userAuthSettings)
  const { currentTimeZoneId } = userSettings;
  // const { isAuth, setIsAuth, loader} = useAuthToken();
  const {checkCurrentTimeZone, getCurrentTimeZone, getDetectedTimeZone} = useTimeZone(new Date(), currentTimeZoneId ?? '', 'longGeneric', 'ru-RU')
  const [loadingDecline, setLoadingDecline] = useState(false);
    const [loadingAccept, setLoadingAccept] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const currentTimeZone = -new Date().getTimezoneOffset() / 60;
    const stylesForBtnDiv: React.CSSProperties = {
        width: '100%', 
        display: "flex", 
        flexDirection: "row", 
        justifyContent: "flex-end", 
        alignItems: "center",
        marginTop: '12px', 
        gap: '8px'
    }
  const [editTaskModalIcon, setEditTaskModalIcon] = useState(null);
  const urlTimerHub = (process.env.REACT_APP_API_BASEURL_HUB ?? 'https://api-demo.timetask.ru/') + 'TimerHub';
  const urlUpdateHub = (process.env.REACT_APP_API_BASEURL_HUB ?? 'https://api-demo.timetask.ru/') + 'TaskUpdateHub';
  const [connectionTimerHub, setConnectionTimerHub] = useState<HubConnection | null>(null);
  const [connectionUpdateHub, setConnectionUpdateHub] = useState<HubConnection | null>(null);
  useTimerSync(isAuth, connectionTimerHub, connectionUpdateHub);
  const location = useLocation();
  const updatePageName = (payload: { pageName: string; index: number; }) => {        
    setPageName({
      pageName: payload.pageName,
      index: payload.index
    })
    navigate(`${arrayLink[payload.index]}`)    
    setMenuPage(false)
  }  
  
  console.log(editTaskModalIcon);
  

  const arraySvg = [
    <TodaySvg style={{fill: '#5932EA', width: '16px', height: '16px' }} />,
    <CalendarSvg style={{fill: '#5932EA', width: '16px', height: '16px' }} />,
    <IncomingSvg style={{fill: '#5932EA', width: '16px', height: '16px' }} />,
    <NotesIcon className='notes-page-icon' style={{width: '16px', height: '16px' }} />
  ];

  const arrayPages: MenuPageSelect[] = [
    {img: <TodaySvg fill='#232360' style={{width: '16px', height: '16px'}}/>, title: 'Мой день'},
    {img: <CalendarSvg fill='#232360' style={{width: '16px', height: '16px'}} />, title: 'Календарь'},
    {img: <IncomingSvg fill='#232360' style={{width: '16px', height: '16px'}} />, title: 'Входящие задачи'},
    {img: <NotesIcon fill='#232360' style={{width: '16px', height: '16px'}} />, title: 'Заметки'}
  ]
  const arrayLink = ['/', '/calendar', '/viewlist', '/notes'];
  let avaUrl = useSelector((state: RootState) => state.settings.avatarUrl);
  useOutsideClick(userMenuRef, () => setMenuActiv(false), menuActiv && windowScreen > 576);
  // const clearSelect = event => {
  //   if(event.ctrlKey){
  //       return;
  //   }else{
  //       TaskSelection("clear");
  //       return;
  //   }
  // }
  const refCloseSelectPage = useRef<HTMLDivElement>(null);
  useOutsideClick(refCloseSelectPage, () => setMenuPage(false), menuPage);

  const handleDeclineNewTimeZone = () => {
    setLoadingDecline(true)
    request.put('/Settings/', {
        userId: localStorage.getItem('userID'),
        currentTimeZoneId: getCurrentTimeZone(),
        timeZoneId: userSettings.timeZoneId,
        settingsType: userSettings.settingsType,
        isSmartDateRecognition: userSettings.isSmartDateRecognition,
        isTimeTracking: userSettings.isTimeTracking,
        timeZone: userSettings.timeZone,
        currentTimeZone: userSettings.currentTimeZone,
        isGCalendarIntegrated: userSettings.isGCalendarIntegrated
    })
    .then((response) => dispatch(loadUserSettings({...response.data, 
                                                    currentTimeZoneId: response.data.currentTimeZoneId, 
                                                    timeZoneId: userSettings.timeZoneId})))
    .then(() => setLoadingDecline(false))
    .then(() => setModalShow(false));
} 

const handleAddNewTimeZone = () => {
    setLoadingAccept(true)
    request.put('/Settings/', {
        userId: localStorage.getItem('userID'),
        currentTimeZoneId: getCurrentTimeZone(),
        timeZoneId: getCurrentTimeZone(),
        settingsType: userSettings.settingsType,
        isSmartDateRecognition: userSettings.isSmartDateRecognition,
        isTimeTracking: userSettings.isTimeTracking,
        timeZone: userSettings.timeZone,
        currentTimeZone: userSettings.currentTimeZone,
        isGCalendarIntegrated: userSettings.isGCalendarIntegrated
    })
    .then((response) => dispatch(loadUserSettings({...response.data, 
                                                    currentTimeZoneId: response.data.currentTimeZoneId, 
                                                    timeZone: response.data.timeZoneId})))
    .then(() => setLoadingAccept(false))
    .then(() => setModalShow(false));
}

useEffect(() => {
  if (checkCurrentTimeZone()) {
  } else {
      setModalShow(true)
  }
  /* eslint-disable-next-line react-hooks/exhaustive-deps */
}, [currentTimeZoneId, userSettings, currentTimeZone])

  /*Set connection to hub*/
// @microsoft/signalr подгружается динамически — не в стартовом чанке (правка 2)
const connectHub = (url: string) =>
  import('@microsoft/signalr').then((signalR) =>
    new signalR.HubConnectionBuilder()
      .withUrl(url, {
        transport: signalR.HttpTransportType.LongPolling
      })
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: (retryContext) => {
          return 60000;
        }
      })
      .build()
  );

useEffect(() => {
  if (!isAuth) {
    connectionTimerHub?.stop();
    connectionUpdateHub?.stop();
    return;
  }

  let cancelled = false;
  let retry: ReturnType<typeof setTimeout> | undefined;
  let timer: ReturnType<typeof startUserHub> | undefined;
  let update: ReturnType<typeof startUserHub> | undefined;
  const userId = localStorage.getItem('userID');
  if (!userId) return;
  const stopConnections = () => Promise.allSettled([timer?.stop(), update?.stop()]);
  const startConnections = async () => {
    try {
      const [timerHub, updateHub] = await Promise.all([connectHub(urlTimerHub), connectHub(urlUpdateHub)]);
      if (cancelled) return;
      timer = startUserHub(timerHub, userId, () => { dispatch(taskCreated()); });
      update = startUserHub(updateHub, userId, async () => {
        // Receive refreshes this tab and its peers after rejoining the group.
        await updateHub.invoke('Send', userId);
      });
      await Promise.all([timer.ready, update.ready]);
      if (!cancelled) { setConnectionTimerHub(timerHub); setConnectionUpdateHub(updateHub); }
    } catch {
      await stopConnections();
      if (!cancelled) retry = setTimeout(startConnections, 5000);
    }
  };
  startConnections();
  return () => { cancelled = true; if (retry) clearTimeout(retry); stopConnections(); };
}, [isAuth]);// eslint-disable-line react-hooks/exhaustive-deps
  /***************************/

  useEffect(() => {
    switch (location.pathname) {
      case '/':
        document.title = 'Мой день'
        break;
      case '/calendar':
        document.title = 'Календарь'
        break;
      case '/viewlist':
        document.title = 'Входящие задачи'
        break;
      case '/automation':
        document.title = 'Повторяющиеся задачи'
        break;
      case '/profile':
        document.title = 'Профиль'
        break;
      case '/settings':
        document.title = 'Настройки'
        break;
      case '/statistics':
        document.title = 'Статистика'
        break;
      case '/completed':
        document.title = 'Выполненные'
        break;
      case '/removed_todo':
        document.title = 'Корзина'
        break;
      case '/tags':
        document.title = 'Метки'
        break;
      case '/login':
        document.title = 'Вход - Timetask'
        break;
      case '/login/':
        document.title = 'Вход - Timetask'
        break;
      case '/register':
        document.title = 'Регистрация - Timetask'
        break;
      case '/forgot_password':
        document.title = 'Восстановление пароля'
        break;
      case '/notes':
        document.title = 'Заметки'
        break;
      case '/templates':
        document.title = 'Шаблоны задач'
        break;
      default:
        document.title = 'Timetask'
        break;
    }
  }, [location.pathname])

  useEffect(() => {
    arrayLink.map((item, index) => {
      if (item === location.pathname || (item !== '/' && location.pathname.startsWith(item + '/'))) {
        setPageName({
          pageName: arrayPages[index].title,
          index: index
        })
      }
      return index;
    })
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [location.pathname])

  useEffect(() => {
    if (!isAuth) return;
    const load = () => { Promise.allSettled([dispatch(getAvatar()), dispatch(getTagsList())]); };
    load();
    return subscribeSessionRecovered(load);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [isAuth])

  useEffect(() => {
    if (!isAuth) return;
    const load = () => {
      return request.get('/Settings/', {
        params: { UserId: localStorage.getItem('userID') }
      })
        .then((response) => {
          dispatch(loadUserSettings(response.data))
          if (response.data.focusMode !== undefined) {
            dispatch(focusedTaskSlice.actions.changeVariantView({ varinatView: response.data.focusMode }))
          }
        }).catch(() => {});
    };
    load();
    return subscribeSessionRecovered(load);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [isAuth])
  const headerRef = useRef<HTMLElement>(null);
  
  useEffect(() => subscribeSessionEnd(() => {
    dispatch({type: UserAuthActionTypes.FETCH_DATA_USER_ACCOUNT_LOGOUT});
    navigate(loginLocationAfterSessionExpired(window.location.pathname, window.location.search), {replace: true});
  }), [dispatch, navigate]);

  useEffect(() => {
    const userID = localStorage.getItem('userID');
    if (getAccessToken() || getRefreshToken()) dispatch(getUserData());
    else {
      if (userID || getAccessToken() || getRefreshToken()) endSession();
      else dispatch({type: UserAuthActionTypes.FETCH_DATA_USER_ACCOUNT_LOGOUT});
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  useEffect(() => {
    if (!sessionError || loading) return;
    const retry = () => dispatch<any>(getUserData());
    const timer = setTimeout(retry, 5000);
    window.addEventListener('online', retry);
    window.addEventListener('focus', retry);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('online', retry);
      window.removeEventListener('focus', retry);
    };
  }, [sessionError, loading, dispatch]);

  const handleLoginPage = () => {
    navigate('/')
  }

  const handleRegisterPage = () => {
    navigate('/register')
  }
  

  if(!isAuth && (loading || sessionError)) {
    return <div style={{display: 'flex', justifyContent:'center', alignItems: 'center', height: '100vh', width: '100wh'}}>
      <Loader />
      </div>
  }

  return (
    <>
    {isAuth ? (
      <>
        <header id="Head" className='header' ref={headerRef}>
          <img className='header__logo' alt='logo' src={logo} style={{ cursor: 'pointer' }} onClick={() => navigate('/', { replace: true })} />
          <EPG date={ConverterUTC({method: 'object', settingsUser: userSettings})} />
          <ul className="header__menu">
          {windowScreen > 576 && <> <div style={{display: 'flex', gap: '16px'}}><FocusTaskBtn /><MatrixButton /></div><Feedback /></>}
            {
              windowScreen > 576 ?
              <li ref={userMenuRef} className='user-menu-anchor'>
                <button className='btn-menu' onClick={() => setMenuActiv(!menuActiv)}>
                  <img className='user-avatar' src={avaUrl || DEFAULT_AVATAR_URL} onError={handleAvatarLoadError} alt='' />
                </button>
                <UserMenu
                  active={menuActiv}
                  avatar={avaUrl}
                  setActive={setMenuActiv}
                />
              </li> :
                <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                  <div ref={refCloseSelectPage} className='pagePicker' onClick={() => setMenuPage(!menuPage)}>
                    <span className='pagePicker__span'>
                      {arraySvg[pageName.index]}
                      <p>{pageName.pageName}</p>
                      <ArrowDown className={menuPage ? 'rotated-arrow' : 'unrotated-arrow'} />
                    </span>
                  </div>
                    {
                      menuPage ?
                      <DDselectPage arrayPages={arrayPages}
                      arrayLink={arrayLink}
                      currentLocation={location.pathname}
                      updatePageName={updatePageName} /> : null
                    }
                  <div style={{display: 'flex', gap: '10px'}}>
                    <Feedback/>
                    <button className='btn-menu__mobile' aria-label='Открыть меню' aria-expanded={menuActiv} aria-controls='user-menu-mobile' onClick={() => setMenuActiv(!menuActiv)}>
                      <BurgerMenu style={{width: '16px', height: '16px'}}></BurgerMenu>
                    </button>
                  </div>
                </div>
            }
            {
              windowScreen <= 576 &&
                <UserMenuMobile 
                  active={menuActiv}
                
                  setActive={setMenuActiv}
                  avatar={avaUrl}
                />
            }
          </ul>
        </header>
        {/* <body> */}
        {
                modalShow &&
                <ModalWindow updateModalState={setModalShow}
                modalShow={modalShow}
                logo={true}
                position={'center'}
                disabledOutsideClose={true}
                disabledCloseBtn={true}
                title={'У вас изменился часовой пояс. Поменять его на новый?'}>
                    <div>
                        <p>Новый часовой пояс <span style={{fontWeight: 600}}>{getDetectedTimeZone()}</span> — его можно будет изменить в настройках</p>
                        <div  style={stylesForBtnDiv}>
                            <Button title={'Оставить прошлый'}
                                    loading={loadingDecline}
                                    btnType="default"
                                    
                                    onClickFunc={handleDeclineNewTimeZone}
                                    
                            /> 
                            <Button title={'Да, сделать новый'}
                                    loading={loadingAccept}
                                    btnType="filled"
                                    
                                    onClickFunc={handleAddNewTimeZone}
                                    
                            />
                        </div>
                    </div>
                </ModalWindow>
            }
          {/* {
            modalShow &&
            <ModalWindow updateModalState={updateModalState}
              modalShow={modalShow}
              title={titleModal}
              disabledCloseBtn={isDisabledCloseBtn}
              disabledOutsideClose={isDisabledOutsideClose}
              description={descriptionModal}
              logo={logoModal}
              buttons={buttonsModal} />
          } */}
          
        {/* </body> */}
        <div>
          <connectionHubContext.Provider value={{timerHub: connectionTimerHub, updateHub: connectionUpdateHub}}>
            <TimerError />
            <Suspense fallback={<Loader />}>
            <Routes>
              <Route path="/" element={<TodayTask setIcon={setEditTaskModalIcon} />} />
              <Route path="/task/:id" element={<><TodayTask setIcon={setEditTaskModalIcon} /><EditModalTask modalTitle={'Мой день'} /></>} />
              <Route path="/login/" element={<LoginPage/>} />
              <Route path="/register" element={<Register/>} />
              <Route path="/viewlist" element={<IncomingTodosPage setIcon={setEditTaskModalIcon} />} />
              <Route path="/viewlist/task/:id/" element={<><IncomingTodosPage setIcon={setEditTaskModalIcon} /><EditModalTask modalTitle={'Входящие задачи'} /></>} />
              <Route path="/completed" element={<CompletedTodosPage setIcon={setEditTaskModalIcon} />} />
              <Route path="/completed/task/:id/" element={<><CompletedTodosPage setIcon={setEditTaskModalIcon} /><EditModalTask disabled={true} modalTitle={'Выполненные'} /> </>} />
              <Route path="/templates" element={<TaskTemplatePage setIcon={setEditTaskModalIcon} />} />
              <Route path="/templates/task/:id/" element={<><TaskTemplatePage setIcon={setEditTaskModalIcon} /><EditModalTask modalTitle={'Шаблоны задач'} /> </>} />
              <Route path="/calendar" element={<CalendarPage setIcon={setEditTaskModalIcon} />} />
              <Route path="/calendar/task/:id/" element={<><CalendarPage setIcon={setEditTaskModalIcon} /><EditModalTask modalTitle={'Календарь'} /> </>} />
              <Route path="/removed_todo" element={<DeletedTodosPage setIcon={setEditTaskModalIcon} />} />
              <Route path="/removed_todo/task/:id/" element={<><DeletedTodosPage setIcon={setEditTaskModalIcon} /><EditModalTask disabled={true} modalTitle={'Корзина'} /></>} />
              <Route path="/notes" element={<NotesPage />} />
              <Route path='/storybook' element={<SubscriptionPage />} />
              <Route path='/storybook/productivity-summary' element={<ProductivitySummaryPreview />} />
              <Route path='/subscription' element={<SubscriptionPaymentReturnPage />} />
              <Route path="/notes/:id" element={windowScreen > 576 ? <NotesPage /> : <NotesPageMobile />} />
              <Route path="/tags" element={<TagsPage />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/automation" element={<RepeatTemplatePage setIcon={setEditTaskModalIcon} />} />
              <Route path="/automation/task/:id/" element={<><RepeatTemplatePage setIcon={setEditTaskModalIcon} /><EditModalTask modalTitle={'Повторяющиеся задачи'} /> </>} />
              <Route path='/integrations' element={<Settings/>}></Route>
              <Route path="/oauth/callback/" element={<SuccessGoogle />} />
              <Route path='/profile' element={<Settings />} />
              <Route path='/test' element={<Settings />} />
              <Route path='/statistics' element={<Settings />}>
                <Route path='task/:id' element={<EditModalTask disabled={true} modalTitle={'Выполненные'} />} />
              </Route>
              <Route path="/*" element={<NotFoundPage setIsDisabledHeaderBtns={setIsDisabledHeaderBtns} />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path='/register_success' element={<SuccessPage title='Вы успешно зарегистрировались' typeIcon={1} />} />
            </Routes>
            </Suspense>
          </connectionHubContext.Provider>
        </div>
      </>
    ) : (
      <>
        <header className='header'>
          <img className='header__logo-nologin' alt='logo' src={logo} style={{ cursor: 'pointer' }} onClick={() => navigate('/', { replace: true })} />
          {window.screen.width > 576 ?
            <div className='header__buttons' style={isDisabledHeaderBtns ? { display: 'none' } : { display: 'flex' }}>
              <Button title='Регистрация' onClickFunc={handleRegisterPage} btnType="default" btnSize="xl" />
              <Button title='Войти' onClickFunc={handleLoginPage} btnType="filled" btnSize="xl" />
            </div> : null}
        </header>
        <Suspense fallback={<Loader />}>
        <Routes>
          <Route path='/subscription' element={<SubscriptionPaymentReturnPage />} />
          <Route path="/register" element={<Register/>} />
          <Route path="/login/" element={<LoginPage/>} />
          <Route path="/" element={<LoginPage/>} />
          <Route path="/forgot_password" element={<ForgotPassword />} />
          <Route path="/ResetPassword/" element={<ResetPasswordP />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path='/auth/vk/callback/' element={<SuccessAuth typeAuth='vk'/>}/>
          <Route path='/auth/yandex/callback/' element={<SuccessAuth typeAuth='yandex'/>}/>
          <Route path="/*" element={<NotFoundPage setIsDisabledHeaderBtns={setIsDisabledHeaderBtns} />} />
        </Routes>
        </Suspense>
      </>
    )
    }
    </>
  )
}

export default App;
